// src/App.js
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import DashboardHome from "./pages/DashboardHome";
import ShopProfile from "./pages/ShopProfile";
import Inventory from "./pages/Inventory";
import VehicleDetail from "./pages/VehicleDetail";
import BookingTimeline from "./pages/BookingTimeline";
import RevenueDashboard from "./pages/RevenueDashboard";
import SupportPage from "./pages/SupportPage";
import AuthPage from "./pages/AuthPage";
import BookingDetail from "./pages/BookingDetail";
import ProtectedRoute from "./components/ProtectedRoute";
import Layout from "./components/Layout";

function App() {
  return (
    <Router>
      <Routes>
        {/* Public Route */}
        <Route path="/auth" element={<AuthPage />} />

        {/* Protected routes nested within Layout */}
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          }
        >
          <Route index element={<DashboardHome />} />
          <Route path="profile" element={<ShopProfile />} />
          <Route path="booking/:bookingId" element={<BookingDetail />} />
          <Route path="inventory" element={<Inventory />} />
          <Route path="vehicle/:id" element={<VehicleDetail />} />
          <Route path="revenue" element={<RevenueDashboard />} />
          <Route path="support" element={<SupportPage />} />
          <Route path="timeline" element={<BookingTimeline />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
